<div id="filtros">
    
    <h3>Filtrar por:</h3>

    <mat-accordion>
        <mat-expansion-panel [expanded]="true">
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Orden
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field>
                <mat-label>Ordenar por</mat-label>
                <mat-select name="filter">
                    <mat-option *ngFor="let option of filterOptions" [value]="option.value">
                        {{option.viewValue}}
                    </mat-option>
                </mat-select>
            </mat-form-field>

        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Precio
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field>
                <input matInput type="number" style="width: 300px;" id="minPrice" name="minPrice" placeholder="Desde">
            </mat-form-field>
            <mat-form-field>
                <input matInput type="number" style="width: 300px;" id="maxPrice" name="maxPrice" placeholder="Hasta">
            </mat-form-field>
        </mat-expansion-panel>

        <mat-expansion-panel>
            <mat-expansion-panel-header>
                <mat-panel-title>
                    Puntos
                </mat-panel-title>
            </mat-expansion-panel-header>

            <mat-form-field>
                <input matInput type="number" style="width: 300px;" id="minPoints" name="minPoints" placeholder="Desde">
            </mat-form-field>
            <mat-form-field>
                <input matInput type="number" style="width: 300px;" id="maxPonts" name="maxPoints" placeholder="Hasta">
            </mat-form-field>
        </mat-expansion-panel>

    </mat-accordion>
</div>